var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-center"},[_c('div',{class:[_vm.canReact && 'cursor-pointer', 'flex', 'flex-row', 'items-end'],on:{"click":_vm.toggleUpvote,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleUpvote($event)}}},[_c('div',{staticClass:"flex flex-row"},[_c('OzIcon',{class:[
          _vm.currentUserUpvoted
            ? _vm.isPadletColorSchemeDark
              ? 'text-canary-500'
              : 'text-grape-500'
            : _vm.isPadletColorSchemeDark
            ? 'text-light-text-300'
            : 'text-dark-text-300' ],attrs:{"name":_vm.currentUserUpvoted ? 'like_filled' : 'like_outline',"size":20}})],1),_vm._v(" "),_c('span',{class:[
        'text-12-16',
        'font-sans',
        'ml-0.5',
        _vm.currentUserUpvoted
          ? _vm.isPadletColorSchemeDark
            ? 'text-light-text-200'
            : 'text-dark-text-200'
          : _vm.isPadletColorSchemeDark
          ? 'text-light-text-300'
          : 'text-dark-text-300' ]},[_vm._v("\n      "+_vm._s(_vm.upvoteCount)+"\n    ")])]),_vm._v(" "),_c('div',{class:[_vm.canReact && 'cursor-pointer', 'flex', 'flex-row', 'items-end', 'ml-1'],on:{"click":_vm.toggleDownvote,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleDownvote($event)}}},[_c('div',{staticClass:"flex flex-row"},[_c('OzIcon',{class:[
          _vm.currentUserDownvoted
            ? _vm.isPadletColorSchemeDark
              ? 'text-canary-500'
              : 'text-grape-500'
            : _vm.isPadletColorSchemeDark
            ? 'text-light-text-300'
            : 'text-dark-text-300' ],attrs:{"name":_vm.currentUserDownvoted ? 'dislike_filled' : 'dislike_outline',"size":20}})],1),_vm._v(" "),_c('span',{class:[
        'text-12-16',
        'font-sans',
        'ml-0.5',
        _vm.currentUserDownvoted
          ? _vm.isPadletColorSchemeDark
            ? 'text-light-text-200'
            : 'text-dark-text-200'
          : _vm.isPadletColorSchemeDark
          ? 'text-light-text-300'
          : 'text-dark-text-300' ]},[_vm._v("\n      "+_vm._s(_vm.downvoteCount)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }